import type { ReactNode } from 'react';
import type { BadgeTone } from '@fleet/shared';

export function Badge({ tone = 'neutral', children }: { tone?: BadgeTone; children: ReactNode }) {
  return <span className={`vs-badge vs-badge--${tone}`}>{children}</span>;
}
